import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ResearchIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g
                    fill="#210071"
                    fillRule="nonzero"
                    transform="translate(.4 .4)"
                >
                    <path d="M8.1 0a8.1 8.1 0 100 16.2A8.1 8.1 0 008.1 0zm0 1.2a6.9 6.9 0 110 13.8 6.9 6.9 0 010-13.8z"></path>
                    <path d="M13.6 12.7514719L18.9485281 18.1 18.1 18.9485281 12.7514719 13.6z"></path>
                    <path d="M3.351 7.5L5.15633472 5.69513714 8.656 10.195 12.6757359 6.17573593 13.5242641 7.02426407 8.54366528 12.0048629 5.043 7.506 3.84852814 8.7 0.6 8.7 0.6 7.5z"></path>
                </g>
            </g>
        </SvgIcon>
    );
};
